import { WaypointTelematicsData } from "@deathstar/types/waypoint";
import { blazar } from "../util/blazar";

export const telematics = {
    get: (accountId: string) => {
        return blazar.fetchJson<WaypointTelematicsData>(`/waypoint/telematics/${accountId}`);
    },
};
